const addRUTHyphen = rut => {
    if(rut.includes('-')) return rut
    let lgt = rut.length
    let dv = rut.substr(lgt - 1)
    let rutSinDV = rut.substr(0, lgt - 1)
    return rutSinDV + '-' + dv
}

const removeRUTHyphen = rut => {
    if(!rut.includes('-')) return rut
    const aux = rut.split('-')
    return '' + aux[0] + aux[1]
}

const removeRUTDots = rut => {
    if(!rut.includes('.')) return rut
    const aux = rut.split('.')
    let rutString = ''
    aux.forEach(substr => {
        rutString += substr
    })
    return rutString
}

const addRUTDots = rut => {

}


export {
    addRUTHyphen,
    removeRUTHyphen
}